/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
export const sourceNames = new Map([
  ["SR", "Stadsarchief Rotterdam"],
  ["SA", "Stadsarchief Amsterdam"],
  ["SB", "Stadsarchief Breada"],
  ["HG", "Haags Gemeentearchief"],
  ["UA", "Utrechts Archief"],
  ["NA", "Noord-hollands archief"],
  ["KR", "Krant"],
  ["SM", "Streekarchief Midden-Holland"],
  ["FO", "Fotograaf Rotterdam"],
  ["RT", "Regionaal Archief Tilburg"],
  ["DR", "Doopboek Rotterdam"],
  ["DH", "Doopboek Haarlem"],
  ["GR", "Gereformeerd Trouwboek Rotterdam"],
  ["GB", "Gereformeerd Begraafboek Rotterdam"],
  ["SV", "Streekarchief Voorne-Putten"],
  ["DW", "Doopboek Waalse kerk Den Haag"],
  ["TW", "Trouwboek Waalse kerk Den Haag"],
  ["FR", "France, Protestant Church Records, 1536-1897 (FamilySearch)"],
  ["WF", "Fiches op de Waalse registers, 1500-1828"],
  ["DZ", "Doopboek Nederlands Hervormde kerk Zutphen"],
  ["TZ", "Trouwboek Nederlands Hervormde kerk Zutphen"],
  ["DB", "Doopboek Nederlands Hervormde kerk Breda"],
  ["TB", "Trouwboek Nederlands Hervormde kerk Breda"],
  ["DA", "Doopboek Rooms - Katholiek kerk Appeltern"],
  ["DP", "Doop- en trouw boek Rooms - Katholiek kerk Puijflijk"],
  ["HD", "Haarlem DTB"],
  ["GA", "Gelders Archief"],
  ["RN", "RooyNet (digitale archief gemeente Venray)"],
  ["RB", "Registers van de burgerlijke stand"],
  ["OV", "Overig"],
]);

export const sourceTypes = new Map([
  ["OK", "Overlijdensadvertentie"],
  ["OA", "Overlijdensakte"],
  ["GA", "Geboorteakte"],
  ["HA", "Huwelijksakte"],
  ["HK", "Huwelijkskaart"],
  ["KH", "Huwelijksadvertentie"],
  ["VA", "Verklaring van Armoede"],
  ["VT", "Volkstelling"],
  ["LA", "Doodgeboren kind"],
  ["NM", "Nationale Militie"],
  ["BI", "Begraafinschrijving"],
  ["PR", "Patiëntenregister"],
  ["IN", "Insinuatie"],
  ["GK", "Gezinskaart"],
  ["OV", "Overig"],
]);
